import {DateFilterProvider} from '@github-ui/filter-core/providers'
import {ArrowSwitchIcon, CalendarIcon} from '@primer/octicons-react'
import {singleValueFilterTypes} from '@github-ui/repos-rules-types/shared-filter-types'
import {DEFAULT_FILTER_PRIORITY, type FilterSuggestion} from '@github-ui/filter-core'

function getCurrentDate() {
  return new Date().toLocaleDateString('en-us', {year: 'numeric', month: 'long', day: 'numeric'})
}

export const TIME_RANGE_VALUES: FilterSuggestion[] = [
  {
    value: '@today',
    displayName: 'Today',
    priority: 1,
    icon: ArrowSwitchIcon,
    iconColor: 'var(--fgColor-done, var(--color-done-fg))',
  },
  {
    value: '>@today-1w',
    displayName: 'Past 7 days',
    priority: 2,
    icon: ArrowSwitchIcon,
    iconColor: 'var(--fgColor-done, var(--color-done-fg))',
  },
  {
    value: '>@today-30d',
    displayName: 'Past 30 days',
    priority: 3,
    icon: ArrowSwitchIcon,
    iconColor: 'var(--fgColor-done, var(--color-done-fg))',
  },
  {
    value: () => {
      const now = new Date()
      return `${now.getFullYear()}-${`0${now.getMonth() + 1}`.slice(-2)}-${`0${now.getDate()}`.slice(-2)}`
    },
    displayName: getCurrentDate(),
    priority: 4,
    icon: CalendarIcon,
  },
]

export class CreatedFilterProvider extends DateFilterProvider {
  constructor() {
    super(
      {
        displayName: 'Creation date',
        key: 'created',
        priority: DEFAULT_FILTER_PRIORITY,
        icon: CalendarIcon,
        description: 'Creation date',
      },
      TIME_RANGE_VALUES,
      {
        filterTypes: singleValueFilterTypes,
        priority: DEFAULT_FILTER_PRIORITY,
      },
    )
  }
}
